import { VortexClient } from "./client";
import { SourceMaps } from "./shared/sourcemaps";

export class SingletonBox {
	clients: VortexClient[] = [];
	globals: Map<Self, VortexClient> = new Map();
	documents: Map<Document, VortexClient> = new Map();
	locations: Map<Location, VortexClient> = new Map();

	sourcemaps: SourceMaps = {};

	constructor(public ownerclient: VortexClient) {}

	registerClient(client: VortexClient, global: Self) {
		this.clients.push(client);
		this.globals.set(global, client);
		this.documents.set(global.document, client);
		this.locations.set(global.location, client);
	}
}
